export default __webpack_public_path__ + "static/media/Kendrick Wong.077a799b.png";